module.exports = __webpack_public_path__ + "img/skull_7_bj.d77ed3ca.png";